import { render, staticRenderFns } from "./ContractExpireDialog.vue?vue&type=template&id=197a8dbc&scoped=true"
import script from "./ContractExpireDialog.vue?vue&type=script&lang=js"
export * from "./ContractExpireDialog.vue?vue&type=script&lang=js"
import style0 from "./ContractExpireDialog.vue?vue&type=style&index=0&id=197a8dbc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197a8dbc",
  null
  
)

export default component.exports